/*
 *  -----------------------------------------------------------------------
 *    <copyright file="risk-reviews-grid.helper.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2024 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { Attendee, RiskReview } from '@interfaces/report-templates.interface';

interface IWorker {
    firstName?: string | null;
    lastName?: string | null;
    jobTitle?: string | null;
}

export const getFullNameAndJob = <T extends IWorker>(item: T) =>
    `${item.firstName} ${item.lastName}${item.jobTitle ? ` - ${item.jobTitle}` : ''}`;

export const formRiskReviewData = (data: RiskReview[]) =>
    data.map((riskReview) => ({
        ...riskReview,
        _attendees: riskReview.attendees ?? [],
        _attendeesDisplay: riskReview.attendees?.map((attendee: Attendee) => getFullNameAndJob(attendee)).join(', '),
        _isOpen: !riskReview.endDate,
    }));
